import { Validator, NG_VALIDATORS, FormControl } from "@angular/forms";
import { Directive, Input } from "@angular/core";

@Directive({
  selector: "[autocompleteValidator]",
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: AutoCompleteValidatorDirective,
      multi: true,
    },
  ],
})
export class AutoCompleteValidatorDirective implements Validator {
  @Input("field") field: string = "";
  validate(control: FormControl) {
    if (control.value && control.value[this.field]) {
      return null;
    }
    return { required: true };
  }
}
